import HttpClient from "../HttpClient";
export default class AssessmentService{
    async fetchAllResouces(){
        let data = await HttpClient.get("/centaurus/assessment/tree");
        return data.data;
    }
}